package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_product_general

import com.varabyte.kobweb.browser.http.AbortController
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.update_cash_bid_img.UpdatedCashBidImgModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_product_general.UpdateProductCashBidImageRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

import org.hs_soft.runmynesto.domain.config.Errors


class UpdateProductCashBidImageRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): UpdateProductCashBidImageRepository {

    private var currentAbortController: AbortController? = null

    override suspend fun updateProductCashBidImage(
        image: String,
        id: String
    ): UpdatedCashBidImgModel {

        currentAbortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
            mutation uploadImgBase64(${'$'}file: String!, ${'$'}type: ImgType!, ${'$'}id: ID!) {
              cashAssist {
                img: uploadImgBase64(file: ${'$'}file, type: ${'$'}type, id: ${'$'}id) {
                  ${ApiUtils.Field.id}
                  ${ApiUtils.Field.uid}
                  ${ApiUtils.Field.key} 
                } 
              }
            }
        """.trimIndent())
            put("variables", buildJsonObject {
                put("file", image)
                put("type", "Product")
                put("id", id)
            })
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = currentAbortController!!,
        )

        return if (result != null) {
            Json.decodeFromString<UpdatedCashBidImgModel>(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }

    override fun cancelCurrentRequest() {
        currentAbortController?.abort()
        currentAbortController = null
    }


}
